var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", { attrs: { href: "#tab-1" } }, [_vm._v("Cargas")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md2: "" } },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    lazy: "",
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "max-width": "290px",
                    "min-width": "290px"
                  },
                  model: {
                    value: _vm.menuDatePickerFechaD,
                    callback: function($$v) {
                      _vm.menuDatePickerFechaD = $$v
                    },
                    expression: "menuDatePickerFechaD"
                  }
                },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''"
                      }
                    ],
                    attrs: {
                      slot: "activator",
                      label: "Fecha Inicio",
                      "persistent-hint": "",
                      "prepend-icon": "event",
                      "error-messages": _vm.errors.collect("fechaDesde"),
                      "data-vv-name": "fechaDesde",
                      readonly: ""
                    },
                    slot: "activator",
                    model: {
                      value: _vm.computedDateFormattedFechaD,
                      callback: function($$v) {
                        _vm.computedDateFormattedFechaD = $$v
                      },
                      expression: "computedDateFormattedFechaD"
                    }
                  }),
                  _c("v-date-picker", {
                    attrs: {
                      "first-day-of-week": "1",
                      locale: "es-cl",
                      scrollable: "",
                      min_x: _vm.minDate
                    },
                    on: {
                      input: function($event) {
                        _vm.menuDatePickerFechaD = false
                      }
                    },
                    model: {
                      value: _vm.filtroGrillaFechaD,
                      callback: function($$v) {
                        _vm.filtroGrillaFechaD = $$v
                      },
                      expression: "filtroGrillaFechaD"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md2: "" } },
            [
              _c(
                "v-menu",
                {
                  ref: "horainicio",
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    "return-value": _vm.time1,
                    transition: "scale-transition",
                    "offset-y": "",
                    "max-width": "290px",
                    "min-width": "290px"
                  },
                  on: {
                    "update:returnValue": function($event) {
                      _vm.time1 = $event
                    },
                    "update:return-value": function($event) {
                      _vm.time1 = $event
                    }
                  },
                  model: {
                    value: _vm.menu1,
                    callback: function($$v) {
                      _vm.menu1 = $$v
                    },
                    expression: "menu1"
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      slot: "activator",
                      label: "Hora Inicio",
                      "prepend-icon": "alarm"
                    },
                    on: {
                      change: function($event) {
                        return _vm.$refs.horainicio.save(_vm.time1)
                      }
                    },
                    slot: "activator",
                    model: {
                      value: _vm.time1,
                      callback: function($$v) {
                        _vm.time1 = $$v
                      },
                      expression: "time1"
                    }
                  }),
                  _vm.menu1
                    ? _c("v-time-picker", {
                        attrs: { "full-width": "" },
                        on: {
                          "click:minute": function($event) {
                            return _vm.$refs.horainicio.save(_vm.time1)
                          },
                          blur: function($event) {
                            _vm.horainicio = _vm.time1
                          }
                        },
                        model: {
                          value: _vm.time1,
                          callback: function($$v) {
                            _vm.time1 = $$v
                          },
                          expression: "time1"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md2: "" } },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    lazy: "",
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "max-width": "290px",
                    "min-width": "290px"
                  },
                  model: {
                    value: _vm.menuDatePickerFechaH,
                    callback: function($$v) {
                      _vm.menuDatePickerFechaH = $$v
                    },
                    expression: "menuDatePickerFechaH"
                  }
                },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''"
                      }
                    ],
                    attrs: {
                      slot: "activator",
                      label: "Fecha Fin",
                      "persistent-hint": "",
                      "prepend-icon": "event",
                      "error-messages": _vm.errors.collect("fechaHasta"),
                      "data-vv-name": "fechaHasta",
                      readonly: ""
                    },
                    slot: "activator",
                    model: {
                      value: _vm.computedDateFormattedFechaH,
                      callback: function($$v) {
                        _vm.computedDateFormattedFechaH = $$v
                      },
                      expression: "computedDateFormattedFechaH"
                    }
                  }),
                  _c("v-date-picker", {
                    attrs: {
                      "first-day-of-week": "1",
                      locale: "es-cl",
                      scrollable: "",
                      max_x: _vm.maxDate
                    },
                    on: {
                      input: function($event) {
                        _vm.menuDatePickerFechaH = false
                      }
                    },
                    model: {
                      value: _vm.filtroGrillaFechaH,
                      callback: function($$v) {
                        _vm.filtroGrillaFechaH = $$v
                      },
                      expression: "filtroGrillaFechaH"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md2: "" } },
            [
              _c(
                "v-menu",
                {
                  ref: "horafin",
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    "return-value": _vm.time2,
                    transition: "scale-transition",
                    "offset-y": "",
                    "max-width": "290px",
                    "min-width": "290px"
                  },
                  on: {
                    "update:returnValue": function($event) {
                      _vm.time2 = $event
                    },
                    "update:return-value": function($event) {
                      _vm.time2 = $event
                    }
                  },
                  model: {
                    value: _vm.menu2,
                    callback: function($$v) {
                      _vm.menu2 = $$v
                    },
                    expression: "menu2"
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      slot: "activator",
                      label: "Hora Fin",
                      "prepend-icon": "alarm"
                    },
                    on: {
                      change: function($event) {
                        return _vm.$refs.horafin.save(_vm.time2)
                      }
                    },
                    slot: "activator",
                    model: {
                      value: _vm.time2,
                      callback: function($$v) {
                        _vm.time2 = $$v
                      },
                      expression: "time2"
                    }
                  }),
                  _c("v-time-picker", {
                    attrs: { "full-width": "", locale: "es-cl" },
                    on: {
                      "click:minute": function($event) {
                        return _vm.$refs.horafin.save(_vm.time2)
                      }
                    },
                    model: {
                      value: _vm.time2,
                      callback: function($$v) {
                        _vm.time2 = $$v
                      },
                      expression: "time2"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md2: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-text-field", {
                  attrs: {
                    label: "Buscar...",
                    "single-line": "",
                    "hide-details": ""
                  },
                  on: { input: _vm.onFilterTextBoxChanged },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            )
          ]),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md1: "" } }, [
            _c(
              "div",
              { staticClass: "text-xs-center" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", small: "" },
                    on: { click: _vm.findbyFecha }
                  },
                  [_c("v-icon", [_vm._v("search")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      flat: "",
                      icon: "",
                      small: "",
                      disabled: _vm.btnDisabled
                    },
                    on: { click: _vm.clearFilters }
                  },
                  [_c("v-icon", [_vm._v("clear")])],
                  1
                )
              ],
              1
            )
          ]),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md1: "" } })
        ],
        1
      ),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { md12: "" } },
            [
              _c("MantenedorGrid", {
                staticClass: "ag-theme-material estilo-grilla",
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.cargasFilter
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }